import { RetailPage } from "../features/retail/pages/retail"
import { DashboardLayout } from "../layouts/DashboardLayout"

export default function RetailDashboard() {
  return (
    <DashboardLayout>
      <RetailPage />
    </DashboardLayout>
  )
}
